import { MOD_SPECIALTY_VALUE } from '@/constants/medicalOnDemand';

const MOD_SPECIALTIES = ['product support', MOD_SPECIALTY_VALUE];

/** True if specialty includes "surgical" or "surgeon" (case-insensitive). */
export const isSurgeon = (specialty: string | undefined): boolean => {
  if (!specialty) {
    return false;
  }

  const specialtyLower = specialty.toLowerCase();

  return specialtyLower.includes('surgical') || specialtyLower.includes('surgeon');
};

/**
 * Expert object with specialty field (handles both spellings from different data sources)
 */
interface ExpertWithSpecialty {
  speciality?: string | null;
  specialty?: string | null;
}

/**
 * Check if an expert is a Medical On Demand (Treatment Support) expert
 *
 * Accepts an expert object and checks both 'speciality' and 'specialty' fields
 * to handle different data source spellings (Algolia uses 'Speciality', API uses 'specialty')
 *
 * @example
 * isMedicalOnDemandExpert({ speciality: "Treatment Support" }) // true
 * isMedicalOnDemandExpert({ specialty: "Treatment Support" }) // true
 * isMedicalOnDemandExpert({ speciality: "Medical Oncology" }) // false
 */
export const isMedicalOnDemandExpert = (
  expert: ExpertWithSpecialty | null | undefined
): boolean => {
  if (!expert) {
    return false;
  }

  const specialty = expert.speciality ?? expert.specialty;

  if (!specialty) {
    return false;
  }

  return MOD_SPECIALTIES.includes(specialty.toLowerCase());
};
